import {
	CREDIT_FORM_HUMAN_NAMES,

	ERRORS,
	ERROR_MESSAGES,
} from "../constants";

const {
	emptyField,
} = ERRORS;

export const getHumanReadableErrorMessages = ({ name, errors }) => {
	const humanReadableName = CREDIT_FORM_HUMAN_NAMES[name];

	return errors
		.map((error) => {
			if (error === emptyField) {
				return ERROR_MESSAGES[error].replace(/\{\}/, humanReadableName);
			}

			return ERROR_MESSAGES[error];
		})
		.reduce((memo, error) => memo || error, "");
};



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/form-errors.js